import {createSlice} from "@reduxjs/toolkit";

const initialAdminMenusState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  adminMenuForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const adminMenusSlice = createSlice({
  name: "adminMenus",
  initialState: initialAdminMenusState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getAdminMenuById
    adminMenuFetched: (state, action) => {
      state.actionsLoading = false;
      state.adminMenuForEdit = action.payload.adminMenuForEdit;
      state.error = null;
    },
    // findAdminMenus
    adminMenusFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createAdminMenu
    adminMenuCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.adminMenu);
    },
    // updateAdminMenu
    adminMenuUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.adminMenuId === action.payload.adminMenu.adminMenuId) {
          return action.payload.adminMenu;
        }
        return entity;
      });
    },
    // deleteAdminMenu
    adminMenuDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.adminMenuId !== action.payload.adminMenuId);
    },
    // deleteAdminMenus
    adminMenusDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.adminMenuId)
      );
    },
  }
});
